// 检测类型
export const checkType = {
  'PULSE': { text: "脉诊" },
  'TONGUE': { text: "AI舌诊" },
  'CORPOREALITY': { text: "体质检测" },
} as const;

// 体质信息
export const contitutionType = {
  'population_characteristics': { text: "群体特征" },
  'disease_predisposition': { text: "发病倾向" },
  'dietary_recommendations': { text: "食疗建议" },
  'dietary_recommendations_suitable': { text: "食疗建议-宜" },
  'dietary_recommendations_avoid': { text: "食疗建议-忌" },
  'common_symptom': { text: "常见表现" },
  'treatment_approach': { text: "调理思路" },
} as const;

// 建议
export const suggestionsType = {
  'overall_suggestion': { text: "总体建议" },
  'emotion_regulation': { text: "情志调摄" },
  'diet_regulation': { text: "饮食调节" },
  'exercise_regulation': { text: "运动健身" },
  'live_regulation': { text: "起居调节" },
  'herbal_regulation': { text: "药饵保健" },
} as const;